import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: ${props => props.theme.font.family.bold};
  background: ${props => props.theme.colors.navBackground};

  &::before {
    content: "";
    min-width: 16px;
    height: 16px;
    margin: 0 0.5rem 0 0;
    background-image: url(${props => props.theme.images.spriteSheet.toString()});
    background-repeat: no-repeat;
    background-position: -89px -548px;
  }
`;

const PcBox = styled(DefaultBox)`
  margin: auto 1rem 2rem 1rem;
  padding: 1rem 0.5rem;
  font-size: 1.4rem;
  border-radius: 0.5rem;

  @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
    margin-bottom: 0.5rem;
    padding: 0.5rem;
  }
`;

const MobileBox = styled(DefaultBox)`
  align-self: flex-start;
  margin: auto 0;
  padding: 0;

  ::before {
    width: 1rem;
    height: 1rem;
    margin: 0;
    background-size: 1118px;
    background-position: -70px -419px;
  }
`;

export const ClockLastLoginDefaultBox = styledByDevice(PcBox, MobileBox);
